import { CommonResponse, TargetMenu } from 'models/common';
import axiosClient from 'utils/axiosClient';
import {
  DisplayTimingGroupAddEditPayload,
  DisplayTimingGroupDetailItem,
  DisplayTimingGroupGetAllParam,
  DisplayTimingGroupListItem,
  DisplayTimingGroupMenuCountItem,
  TargetMenuDisplayTimingGroupPayload,
  UpdateSortOrderPayload,
} from './models';

const TARGET_MENUS_URL = '/display-timing-groups/target-menus';

const displayTimingGroupService = {
  getAll(payload: DisplayTimingGroupGetAllParam): Promise<CommonResponse<Array<DisplayTimingGroupListItem>>> {
    let url = `/display-timing-groups?active=${payload.active}`;
    if (payload.group_name) url += `&group_name=${payload.group_name}`;

    return axiosClient.get(url);
  },
  getBelongMenus(ids: number[]): Promise<CommonResponse<DisplayTimingGroupMenuCountItem[]>> {
    const url = `/display-timing-groups/get-belong-menus?ids=${ids.join(',')}`;
    return axiosClient.get(url);
  },
  getItem(id: number): Promise<CommonResponse<DisplayTimingGroupDetailItem>> {
    const url = `/display-timing-group/${id}`;
    return axiosClient.get(url);
  },
  add(payload: DisplayTimingGroupAddEditPayload): Promise<CommonResponse<any>> {
    const url = '/display-timing-groups';
    return axiosClient.post(url, payload);
  },
  update(id: number, payload: DisplayTimingGroupAddEditPayload): Promise<CommonResponse<any>> {
    const url = `/display-timing-group/${id}`;
    return axiosClient.put(url, payload);
  },
  delete(ids: number[]): Promise<CommonResponse<any>> {
    const url = `/display-timing-groups`;
    return axiosClient.delete(url, { data: { ids } });
  },
  updateSortOrder(payload: UpdateSortOrderPayload[]): Promise<CommonResponse<any>> {
    const url = `/display-timing-groups/update-sort-order`;
    return axiosClient.patch(url, payload);
  },
  getTargetMenuList(payload: { display_timing_group_id?: number }): Promise<CommonResponse<TargetMenu[]>> {
    const params = new URLSearchParams();

    if (payload.display_timing_group_id) {
      params.append('display_timing_group_id', payload.display_timing_group_id.toString());
    }

    const queryString = params.toString();
    const url = queryString ? `${TARGET_MENUS_URL}?${queryString}` : TARGET_MENUS_URL;

    return axiosClient.get(url);
  },
  addTargetMenu(payload: TargetMenuDisplayTimingGroupPayload): Promise<CommonResponse<TargetMenu[]>> {
    return axiosClient.post(TARGET_MENUS_URL, payload);
  },
  deleteTargetMenu(payload: TargetMenuDisplayTimingGroupPayload): Promise<CommonResponse<TargetMenu[]>> {
    return axiosClient.delete(TARGET_MENUS_URL, { data: payload });
  },
};

export default displayTimingGroupService;
